import { createContext, useContext, useEffect, useState } from "react";
import client from "../lib/api";
import {
  getToken, setToken, removeToken,
  startImpersonation, getAdminToken, getImpersonation, clearImpersonation,
} from "../lib/storage";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [impersonating, setImpersonating] = useState(getImpersonation());

  useEffect(() => {
    const token = getToken();
    if (!token) { setLoading(false); return; }
    client.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { removeToken(); clearImpersonation(); })
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => {
    setToken(token);
    setUser(u);
  };
  const logout = () => {
    clearImpersonation();
    removeToken();
    setUser(null);
  };

  // Admin: view AND edit the portal as another user (short-lived token, audited).
  const impersonate = async (uid, name) => {
    const r = await client.post(`/admin/impersonate/${uid}`);
    startImpersonation(r.data.token, { id: uid, name, role: r.data.user.role });
    window.location.assign("/");
  };
  const exitImpersonation = () => {
    const adminToken = getAdminToken();
    if (adminToken) setToken(adminToken);
    clearImpersonation();
    setImpersonating(null);
    window.location.assign("/");
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, loading, impersonating, impersonate, exitImpersonation }}>
      {children}
    </AuthCtx.Provider>
  );
}
